"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Outline = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const styles_1 = require("../../styles");
const context_1 = require("../../styles/context");
const blockClass = (0, nano_theme_1.drule)({
    d: 'block',
    pos: 'relative',
    bdrad: '6px',
    bxz: 'border-box',
    mr: 0,
});
const labelClass = (0, nano_theme_1.drule)({
    ...styles_1.fonts.get('mono', 'mid', 2),
    w: '100%',
    d: 'inline-block',
    bxz: 'border-box',
    pd: 0,
    mr: 0,
    fz: '11.5px',
    tt: 'uppercase',
});
const Outline = ({ className = '', style, label, active, disabled, center, ghost, activeBorderColor = 'neutral', size, children, ...rest }) => {
    const styles = (0, context_1.useStyles)();
    const padding = !size ? 7 : Math.max(0, 7 + size);
    const ghostIdleBg = ghost === 'hint' ? styles.g(0, 0.02) : 'transparent';
    const ghostHoverBg = ghost === 'hint' ? styles.g(0, 0.05) : styles.g(0, 0.04);
    const blockStyle = ghost
        ? {
            bg: active && !disabled ? styles.g(0, 0.06) : ghostIdleBg,
            ta: center ? 'center' : 'start',
            bd: active && !disabled ? `1px solid ${styles.col.get(activeBorderColor, 10)}` : '1px solid transparent',
            bxsh: active && !disabled ? `0 0 0 1px ${styles.col.get(activeBorderColor, 'border-3')}` : 'none',
            pd: `${padding}px ${padding * 2}px`,
            '& *': {
                op: disabled ? 0.5 : 1,
            },
            '&:hover': {
                bg: disabled ? ghostIdleBg : active ? styles.g(0, 0.06) : ghostHoverBg,
                bd: active && !disabled ? `1px solid ${styles.col.get(activeBorderColor, 10)}` : '1px solid transparent',
                bxsh: active && !disabled ? `0 0 0 2px ${styles.col.get(activeBorderColor, 10)}` : 'none',
                '& *': {
                    op: 1,
                },
            },
        }
        : {
            bg: styles.g(0, 0.08),
            ta: center ? 'center' : 'start',
            bd: disabled
                ? `1px dotted ${styles.g(0.8)}`
                : active
                    ? `1px solid ${styles.col.get(activeBorderColor, 10)}`
                    : `1px solid transparent`,
            bxsh: active && !disabled ? `0 0 0 1px ${styles.col.get(activeBorderColor, 'border-3')}` : 'none',
            pd: `${padding}px ${padding * 2}px`,
            '& *': {
                op: disabled ? 0.5 : 1,
            },
            '&:hover': {
                bd: disabled
                    ? `1px solid ${styles.g(0.8)}`
                    : active
                        ? `1px solid ${styles.col.get(activeBorderColor, 10)}`
                        : `1px solid ${styles.col.get('neutral', 7)}`,
                bxsh: active && !disabled ? `0 0 0 2px ${styles.col.get(activeBorderColor, 10)}` : 'none',
                '& *': {
                    op: 1,
                },
            },
        };
    return (React.createElement("div", { ...rest, className: className + blockClass(blockStyle), style: style },
        !!label && (
        // biome-ignore lint/a11y/noLabelWithoutControl: label is used as visual decoration
        React.createElement("label", { className: labelClass({
                col: disabled ? styles.g(0.1) : active ? styles.g(0) : styles.g(0.4),
            }), style: {
                fontSize: 11.5 + 0.5 * (size ?? 0) + 'px',
            } }, label || '\uFEFF')),
        children));
};
exports.Outline = Outline;
